
import moment from 'moment'

const getDaysInWeek = () => {
  return Array.apply(null, { length: 7 })
    .map((_, i) => moment().weekday(i).format('dddd, MMMM Do'))
}

const getDaysInMonth = () => {
  const days = moment().daysInMonth()
  const firstDay = moment().startOf('month')
  const labels = [firstDay.format('MMMM Do')]
  for (let i = 1; i < days; i++) {
    labels.push(firstDay.add(1, 'days').format('MMMM Do'))
  }
  return labels
}

const monthsInYear = () => {
  return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
}

const LABELS = {
  week: {
    labels: getDaysInWeek(),
    stepSize: {
      auction: 5,
      revenue: 1000
    },
    formatCallback: (value) => value.slice(0, 3)
  },
  month: {
    labels: getDaysInMonth(),
    stepSize: {
      auction: 5,
      revenue: 1000
    },
    formatCallback: (value) => value.split(' ')[1].slice(0, -2)
  },
  year: {
    labels: monthsInYear(),
    stepSize: {
      auction: 50,
      revenue: 10000
    },
    formatCallback: (value) => value.slice(0, 3)
  },
  all: {
    labels: [],
    stepSize: {
      auction: 50,
      revenue: 10000
    },
    formatCallback: (value) => value
  }
}

export default LABELS
